const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/teams/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { compactPicklistFilterSchema } from '@/common/zod-schemas/common/compactFilterSchemas';
import { periodSearchSchema } from './-utils/searchParams';
const indexSearchSchema = z.object({
  ...periodSearchSchema,
  roleId: compactPicklistFilterSchema,
  skillId: compactPicklistFilterSchema,
  capacityCondition: compactPicklistFilterSchema,
  openRoleId: compactPicklistFilterSchema,
  openSkillId: compactPicklistFilterSchema
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/teams/')({
  validateSearch: zodValidator(indexSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});